export default function currency(state = 'usd', action) {
  switch (action.type) {
    case 'CURRENCY_UPDATED':
      return action.currency
    default:
      return state
  }
}
